import React from "react"
import { FormProvider, SubmitHandler } from "react-hook-form"

import type { UseFormReturn } from "react-hook-form"

import { useStyles } from "@/components/QuorumFormProvider/Root/Root.styles"

export interface RootProps<T> {
    /** The object returned by React Hook Form's [useForm](https://react-hook-form.com/docs/useform) */
    reactHookForm: UseFormReturn<T>
    /** Function to pass to React Hook Form's [handleSubmit](https://react-hook-form.com/docs/useform/handlesubmit) */
    submitForm: SubmitHandler<T>
    /** Disable HTML5 validation */
    noValidate?: boolean
}

export const Root = <T,>({
    children,
    reactHookForm,
    submitForm,
    noValidate = false,
}: React.PropsWithChildren<RootProps<T>>) => {
    const { classes } = useStyles()

    return (
        <FormProvider {...reactHookForm}>
            <form
                onSubmit={reactHookForm.handleSubmit(submitForm)}
                aria-labelledby="form-title"
                className={classes.form}
                noValidate={noValidate}
            >
                {children}
            </form>
        </FormProvider>
    )
}
